import { render } from "./Shell.vue?vue&type=template&id=33e29744&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"

import "./Shell.vue?vue&type=style&index=0&id=33e29744&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e29744"]])

export default __exports__